export default __webpack_public_path__ + "static/media/116058d9c3b85e8cd0df143d9ce0df66.png";